import React, { lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'

import loadDependencies from './services/dependencies'
import registerSw from './registerServiceWorker'
import { captureStripeReturnMarker } from './services/Billing/stripeReturnMarker'
import './styles/typography.css'
import './services/polyfills'

import ErrorBoundary from './components/ErrorBoundary'
import Preloader from './components/Preloader'

const App = lazy(() => import('./App' /* webpackChunkName: "App" */))

// SG-12652 §13.6 — stash a `?checkout=success` Stripe return marker to
// sessionStorage BEFORE any React component mounts and BEFORE any authed
// API request can fire `signOutCallback` (which would bounce the user to
// /sign-in and drop the URL search string). `StripeReturnHandler` picks
// up the marker post-sign-in and surfaces the celebration dialog.
captureStripeReturnMarker()

// SG-12652 s76b — popup mode is DISABLED by default. The validated
// production UX is same-tab nav with the global `<PortalNavLoader />`
// linear progress bar. Popup mode exists as opt-in infrastructure for
// future rollout. To enable for ad-hoc testing, run in DevTools:
//   window.__SHEETGO_ENABLE_PORTAL_POPUP = true
// The canonical production rollout knob is the BE-served
// `state.user.appConfig.enablePortalPopup` flag (read by
// `services/Billing/portalPopup.js:isPortalPopupEnabled`).

const searchParams = new URLSearchParams(window.location.search)
const searchHasAuthParams = searchParams.has('code') || searchParams.has('access_token')

// SG-14529 — React 18 root API. No StrictMode: react-beautiful-dnd 13 does not
// survive strict effects' mount/unmount/mount, and Material-UI v4 warns on
// findDOMNode under it.
createRoot(document.getElementById('app')).render(
    <ErrorBoundary>
        <Suspense
            fallback={searchHasAuthParams
                ? <></>
                : <Preloader renderLogoOnly />}
        >
            <App />
        </Suspense>
    </ErrorBoundary>
)

// Browser identification
try {
    /* eslint-disable */
    navigator.who = (function () {
        try {
            const N = navigator.appName
            const ua = navigator.userAgent
            let tem
            let M = ua.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i)
            if (M && (tem = ua.match(/version\/([\.\d]+)/i)) != null) M[2] = tem[1]
            M = M ? [M[1], M[2]] : [N, navigator.appVersion, '-?']
            return M.join(' ')
        } catch (e) {
            return null
        }
    })()
    /* eslint-enable */
} catch (e) { /** pass */ }

// Service Worker registration
if (window.top === window.self) { // Check if it's not embedded
    if (navigator && navigator.who) {
        // Ticket #4162 (SG-3337): SW is preventing fetch requests on Firefox
        if (navigator.who.indexOf('Firefox') < 0) registerSw()
    } else {
        registerSw()
    }
} else {
    // Disable PWA installation prompt
    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault()
    })
}

loadDependencies()
